module.exports = __webpack_public_path__ + "static/media/slider_web.c375e88b.jpg";